const useLogos = () => {

    const logoVivetuseguro = 
        <div className="separador__izquierdo">
            <img src="/assets/img/header/img_vivetuseguro_logo.webp" alt="logo_vivetuseguro"/>
        </div>

    const logoCardif = 
        <div>
            <img src="/assets/img/header/logo_cardif.svg" className="logo__cardif" alt="logo_cardif"/>
        </div>
    
    return {logoVivetuseguro, logoCardif}
}

export default useLogos